export enum PixelMatrixValues {
  EXTERIOR = 0,
  INTERIOR = 1,
  EDGE = 2,
  CONSUMED_EDGE = 3,
}
